import { LandingComponent } from './components/landing/landing.component';
import { ReportComponent } from './components/report/report.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@shared';

@NgModule({
  declarations: [ReportComponent, LandingComponent],
  imports: [CommonModule, SharedModule],
})
export class ReportingModule {}
